import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./LoginStyle.css";
import ForgetPasswordPage from "../ForgetPasswordPage/ForgetPasswordPage";
import SignIn from "../SignIn/SignIn";

interface LoginViewProps {
    email: string;
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    password: string;
    setPassword: React.Dispatch<React.SetStateAction<string>>;
    emailError: string;
    passwordError: string;
    passwordVisible: boolean;
    togglePasswordVisibility: () => void;
    login: () => void;
    navigateToSignIn: () => void;
    navigateToForgetPassword: () => void;
}

export const LoginView: React.FC<LoginViewProps> = (props) => {
    const [activeModal, setActiveModal] = useState<"forgot" | "register" | null>(null);

    const closeModal = () => setActiveModal(null);

    return (
        <div className="ja-login-pageWrapper">
            <div className="ja-login-mainContainer">
                {/* Titel */}
                <div className="ja-login-titleContainer">
                    <h2>JuniorAlarm Login</h2>
                </div>

                {/* Benutzername */}
                <div className="ja-login-inputContainer">
                    <label className="ja-login-label">Benutzername</label>
                    <input
                        type="text"
                        value={props.email}
                        onChange={(e) => props.setEmail(e.target.value)}
                        className="ja-login-inputBox"
                        placeholder="Benutzernamen eingeben"
                    />
                    {props.emailError && (
                        <span className="ja-login-errorLabel">{props.emailError}</span>
                    )}
                </div>

                {/* Passwort */}
                <div className="ja-login-inputContainer">
                    <label className="ja-login-label">Passwort</label>
                    <div className="ja-login-passwordContainer">
                        <input
                            type={props.passwordVisible ? "text" : "password"}
                            value={props.password}
                            onChange={(e) => props.setPassword(e.target.value)}
                            className="ja-login-inputBox"
                            placeholder="Passwort eingeben"
                        />
                        <FontAwesomeIcon
                            icon={props.passwordVisible ? faEyeSlash : faEye}
                            onClick={props.togglePasswordVisibility}
                            className="ja-login-passwordIcon"
                        />
                    </div>
                    {props.passwordError && (
                        <span className="ja-login-errorLabel">{props.passwordError}</span>
                    )}
                </div>

                {/* Anmelden Button */}
                <button
                    type="button"
                    className="ja-login-primaryButton"
                    onClick={props.login}
                >
                    Anmelden
                </button>

                {/* Modal Triggers */}
                <div className="ja-login-linkContainer">
                    <button
                        type="button"
                        className="ja-login-forgotPasswordButton"
                        onClick={() => setActiveModal("forgot")}
                    >
                        Passwort ändern
                    </button>
                    <button
                        type="button"
                        className="ja-login-forgotPasswordButton"
                        onClick={() => setActiveModal("register")}
                    >
                        Registrieren
                    </button>
                </div>
            </div>

            {/* --- MODAL OVERLAY FOR EXISTING COMPONENTS --- */}
            {activeModal && (
                <div className="ja-modal-overlay" onClick={closeModal}>
                    <div 
                        className="ja-modal-card" 
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="ja-modal-close" onClick={closeModal}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>

                        {activeModal === "forgot" && <ForgetPasswordPage />}
                        {activeModal === "register" && <SignIn />}
                    </div>
                </div>
            )}
        </div>
    );
};